import { useInitBloc } from 'hooks/useInitBloc';
import { BLoCBase, BLoCParams, renderBlocChild } from 'types/BLoCBase';
import React from 'react';

type State = {};
class BLoC extends BLoCBase<State> {
  public onInit = () => {};
}

const Context = React.createContext<Readonly<BLoC>>({} as any);

export const PublicModuleBLoC: React.FC<BLoCParams<BLoC, State>> = ({ children }) => {
  const bloc = useInitBloc(() => new BLoC());
  return bloc ? <Context.Provider value={bloc}>{renderBlocChild(children, bloc)}</Context.Provider> : null;
};
